import styled from 'styled-components';
export const LabelContainer = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;
export const LabelDiv = styled.div `
  height: 10px;
  ${({ color }) => color && `background: ${color}`};
  width: 10px;
  border-radius: 50%;
  margin-right: 10px;
`;
